import axios from 'axios';

const evidenceService = {
  async submitEvidence(files) {
    const formData = new FormData();
    
    // Add files and their corresponding tags to formData
    files.forEach((file, index) => {
      formData.append('files', file.file);
      
      // Create tag based on document type and index
      const baseTag = file.documentType;
      const tag = files.filter(f => f.documentType === file.documentType).length > 1 
        ? `${baseTag} ${files.filter(f => f.documentType === file.documentType).indexOf(file) + 1}`
        : baseTag;
      
      formData.append('tags', tag);
    });

    try {
      const response = await axios.post('http://localhost:8080/evidence/bulk-upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting evidence:', error);
      throw error;
    }
  }
};

export default evidenceService; 